import axiosInstance, { endpoints } from 'src/lib/axios';

// ----------------------------------------------------------------------

export type Taxeringsstatus = {
  aktuell: boolean;
  /** Sant när bedömningen vilar på fastighetsbeteckningen ensam, utan byggnad att styrka den med. */
  osäker: boolean;
  motivering?: string | null;
  innehavId?: string | null;
  taxeringsår?: number | null;
  taxeringsslag?: string | null;
  förfallodag?: string | null;
  skickDag?: string | null;
  underlagId?: string | null;
  inlämnad: boolean;
};

export const INGEN_TAXERING: Taxeringsstatus = {
  aktuell: false,
  osäker: false,
  inlämnad: false,
};

/**
 * Pågående hämtning, delad mellan samtidiga anropare.
 *
 * `useAttGöra` körs av flera komponenter på samma sida — välkomsthälsningen, listan i listen
 * och i hubbläget en sond per förening — och var och en gjorde sitt eget anrop. Svaret gäller
 * personen och är detsamma för alla, så det räcker med ett. Bara pågående anrop delas; inget
 * svar sparas, så en omhämtning går alltid till servern.
 */
let pågående: Promise<Taxeringsstatus> | null = null;

/**
 * Om den inloggade ska deklarera småhus.
 *
 * Till skillnad från de andra hämtningarna i Att göra gäller den här en person och inte en
 * förening — ett småhus ägs av en fysisk person, ofta en som står i Privatperson-läget och
 * därmed saknar `föreningsId`. Just de användarna är hela målgruppen, så anropet får aldrig
 * villkoras på att en förening är vald.
 *
 * Ett fel lämnar statusen tom i stället för att kasta. Myndighetsdatumen ska visas även när den
 * här hämtningen fallerar.
 */
export async function hämtaTaxeringsstatus(): Promise<Taxeringsstatus> {
  if (pågående) {
    return pågående;
  }

  pågående = axiosInstance
    .get(endpoints.fastighet.fastighetsdeklaration.status)
    .then((svar) => ({ ...INGEN_TAXERING, ...(svar.data ?? {}) }))
    .catch(() => INGEN_TAXERING)
    .finally(() => {
      pågående = null;
    });

  return pågående;
}
